import { render, staticRenderFns } from "./keyWords.vue?vue&type=template&id=6e2f4192&scoped=true"
import script from "./keyWords.vue?vue&type=script&lang=js"
export * from "./keyWords.vue?vue&type=script&lang=js"
import style0 from "./keyWords.vue?vue&type=style&index=0&id=6e2f4192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f4192",
  null
  
)

export default component.exports